export default "__VITE_ASSET__D9n1khEm__"